import React, { useState, Component } from 'react';
import { CheckIcon, StarIcon, ShieldCheckIcon, ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://checkout.cmdigital.online/cart/53995709464860:1';
// Reusable CTA Button Component
const CtaButton = ({
  children,
  className = '',
  href = '#compra'
}: {
  children: React.ReactNode;
  className?: string;
  href?: string;
}) => <a href={href} className={`inline-flex items-center justify-center bg-green-600 hover:bg-green-500 text-white font-bold text-base md:text-lg uppercase py-3 px-6 rounded-lg shadow-[0_0_15px_rgba(22,163,74,0.5)] hover:shadow-[0_0_25px_rgba(22,163,74,0.8)] transition-all duration-300 transform hover:scale-105 animate-[pulse_2s_infinite] text-center w-full max-w-2xl mx-auto ${className}`} data-id="element-3">
    {children}
  </a>;
export function SalesPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-green-300 selection:text-black" data-id="element-4">
      {/* 1. URGENCY BAR - ultra thin */}
      <div className="bg-red-600 text-white text-center py-1 px-4 font-bold text-xs sticky top-0 z-40 shadow-sm" data-id="element-5">
        <p className="flex items-center justify-center gap-2 flex-wrap" data-id="element-6">
          <span data-id="element-7">⏳ OFERTA POR TIEMPO LIMITADO</span>
          <span className="hidden md:inline" data-id="element-8">|</span>
          <span data-id="element-9">🔓 ACCESO DISPONIBLE HOY</span>
        </p>
      </div>

      {/* 2. HERO SECTION - compact */}
      <section className="pt-2 pb-4 px-3 max-w-5xl mx-auto text-center" data-id="element-10">
        <h1 className="text-xl md:text-2xl lg:text-4xl font-extrabold text-black mb-2 leading-tight tracking-tight" data-id="element-11">
          🏋️ SISTEMA COMPLETO DE KINESIOLOGÍA DE LA MUSCULACIÓN
        </h1>

        <a href="#compra" className="block w-full max-w-lg mx-auto mb-2 transform hover:scale-[1.02] transition-transform duration-300" data-id="element-12">
          <img src="https://cdn.magicpatterns.com/uploads/s6zvLcBDTwGRD9fbBVYz1h/mockup_kinesiologia_de_la_musculacion.png" alt="Sistema Completo de Kinesiología de la Musculación" className="w-full h-auto drop-shadow-2xl rounded-xl" data-id="element-13" />
        </a>

        <h2 className="text-base md:text-xl font-bold text-gray-800 mb-1" data-id="element-14">
          Domina la biomecánica, corrige errores y conviértete en un profesional
          real del entrenamiento
        </h2>

        <h3 className="text-sm md:text-lg font-semibold text-red-600 mb-3" data-id="element-15">
          🏋️‍♂️ Para entrenadores, estudiantes y personas que quieren dejar de
          entrenar como amateurs
        </h3>

        <p className="text-sm md:text-base text-gray-600 mb-4 max-w-3xl mx-auto" data-id="element-16">
          Todo lo que necesitas para entender el cuerpo, ejecutar correctamente
          y diseñar entrenamientos profesionales. Sin copiar rutinas. Sin
          improvisar. Sin estancarte.
        </p>

        <CtaButton className="mb-3" data-id="element-17">🔥 SÍ, QUIERO ACCEDER AHORA</CtaButton>

        <p className="flex items-center justify-center gap-2 text-gray-600 font-medium text-xs" data-id="element-18">
          <ShieldCheckIcon className="text-green-500" size={18} data-id="element-19" />✅ Garantía de
          satisfacción de 7 días
        </p>
      </section>

      {/* 3. PAIN POINT SECTION */}
      <section className="py-8 md:py-12 px-3 bg-gray-50 border-y border-gray-200" data-id="element-20">
        <div className="max-w-3xl mx-auto" data-id="element-21">
          <h2 className="text-xl md:text-3xl font-bold text-center mb-4" data-id="element-22">
            Si entrenas, déjame hacerte una pregunta honesta
          </h2>

          <div className="text-sm md:text-lg space-y-3 text-gray-700" data-id="element-23">
            <p className="font-medium text-center text-base md:text-xl" data-id="element-24">
              ¿Te pasa que entrenas duro… pero no estás seguro de si lo estás
              haciendo bien?
            </p>
            <p data-id="element-25">No porque no te esfuerces. No porque no tengas disciplina.</p>
            <p data-id="element-26">
              Sino porque nadie te enseñó a entender realmente cómo funciona el
              cuerpo.
            </p>
            <p className="font-semibold text-center py-4 text-2xl" data-id="element-27">
              Entrenas… Repites ejercicios… Sigues rutinas…
            </p>
            <p data-id="element-28">Pero en el fondo sabes que:</p>

            <ul className="space-y-4 font-medium bg-white p-6 md:p-8 rounded-xl shadow-sm border border-gray-100" data-id="element-29">
              <li className="flex items-start gap-3" data-id="element-30">
                <span className="text-xl mt-0.5" data-id="element-31">❌</span>
                <span data-id="element-32">No entiendes completamente lo que estás haciendo</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-33">
                <span className="text-xl mt-0.5" data-id="element-34">❌</span>
                <span data-id="element-35">No sabes si tu técnica es correcta</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-36">
                <span className="text-xl mt-0.5" data-id="element-37">❌</span>
                <span data-id="element-38">No podrías explicarlo como un profesional</span>
              </li>
            </ul>

            <p className="text-center font-bold text-xl pt-4" data-id="element-39">
              Y eso se siente.
            </p>
          </div>
        </div>
      </section>

      {/* 4. PROBLEM AGITATION */}
      <section className="py-8 md:py-12 px-3 bg-black text-white" data-id="element-40">
        <div className="max-w-3xl mx-auto" data-id="element-41">
          <h2 className="text-xl md:text-3xl font-bold text-center mb-6 text-green-400" data-id="element-42">
            Entrenar no debería sentirse así
          </h2>

          <div className="text-sm md:text-lg space-y-3" data-id="element-43">
            <p data-id="element-44">El problema que nadie dice en voz alta es este:</p>

            <div className="bg-gray-900 p-6 rounded-xl border border-gray-800 my-8" data-id="element-45">
              <p className="mb-4 flex items-start gap-3" data-id="element-46">
                <span className="text-red-500 font-bold" data-id="element-47">❌</span>
                <span data-id="element-48">No estás estancado por falta de esfuerzo…</span>
              </p>
              <p className="flex items-start gap-3" data-id="element-49">
                <span className="text-red-500 font-bold" data-id="element-50">❌</span>
                <span className="font-bold text-white" data-id="element-51">
                  Estás estancado por falta de comprensión
                </span>
              </p>
            </div>

            <p data-id="element-52">
              Hoy en el mundo del fitness hay demasiada información… Pero muy
              poca claridad real.
            </p>
            <p data-id="element-53">Si entrenas, esto seguro te resulta familiar:</p>

            <ul className="space-y-4 my-8" data-id="element-54">
              <li className="flex items-start gap-3" data-id="element-55">
                <span className="text-yellow-500 mt-1" data-id="element-56">●</span>
                <span data-id="element-57">Copias ejercicios sin entenderlos</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-58">
                <span className="text-yellow-500 mt-1" data-id="element-59">●</span>
                <span data-id="element-60">No sabes corregir errores técnicos</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-61">
                <span className="text-yellow-500 mt-1" data-id="element-62">●</span>
                <span data-id="element-63">No entiendes la biomecánica</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-64">
                <span className="text-yellow-500 mt-1" data-id="element-65">●</span>
                <span data-id="element-66">No sabes adaptar un entrenamiento</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-67">
                <span className="text-yellow-500 mt-1" data-id="element-68">●</span>
                <span data-id="element-69">Dudas cuando alguien te pregunta "por qué"</span>
              </li>
            </ul>

            <p className="text-center font-bold text-base md:text-xl text-red-400 mt-4" data-id="element-70">
              Lo peor no es el progreso lento… Es la sensación constante de no
              tener control.
            </p>
          </div>

          {/* 5. EXTRA PERSUASIVE CTA */}
          <div className="mt-6 text-center" data-id="element-71">
            <CtaButton data-id="element-72">🚀 QUIERO ENTRENAR COMO PROFESIONAL</CtaButton>
          </div>
        </div>
      </section>

      {/* 6. SOLUTION SECTION */}
      <section className="py-8 md:py-12 px-3 bg-white" data-id="element-73">
        <div className="max-w-4xl mx-auto text-center" data-id="element-74">
          <h2 className="text-xl md:text-4xl font-black text-black mb-3 uppercase tracking-wide" data-id="element-75">
            ✅ LA SOLUCIÓN
          </h2>
          <h3 className="text-lg md:text-2xl font-bold text-red-600 mb-4" data-id="element-76">
            Sistema Completo de Kinesiología de la Musculación
          </h3>

          <p className="text-sm md:text-lg text-gray-700 mb-6 max-w-3xl mx-auto" data-id="element-77">
            Un sistema profesional, claro y paso a paso, diseñado para que
            entiendas el cuerpo, ejecutes correctamente y pienses como un
            verdadero profesional del entrenamiento.
          </p>

          <div className="grid grid-cols-3 gap-3 mb-6" data-id="element-78">
            <div className="bg-gray-50 p-4 md:p-6 rounded-xl border border-gray-200 shadow-sm" data-id="element-79">
              <div className="text-3xl md:text-4xl mb-2" data-id="element-80">📖</div>
              <h4 className="text-sm md:text-base font-bold" data-id="element-81">
                Estudias el sistema
              </h4>
            </div>
            <div className="bg-gray-50 p-4 md:p-6 rounded-xl border border-gray-200 shadow-sm" data-id="element-82">
              <div className="text-3xl md:text-4xl mb-2" data-id="element-83">🧠</div>
              <h4 className="text-sm md:text-base font-bold" data-id="element-84">
                Entiendes el movimiento
              </h4>
            </div>
            <div className="bg-gray-50 p-4 md:p-6 rounded-xl border border-gray-200 shadow-sm" data-id="element-85">
              <div className="text-3xl md:text-4xl mb-2" data-id="element-86">🏋️‍♂️</div>
              <h4 className="text-sm md:text-base font-bold" data-id="element-87">
                Aplicas con criterio
              </h4>
            </div>
          </div>

          <p className="text-lg md:text-2xl font-black text-black uppercase tracking-wider" data-id="element-88">
            Sin copiar. Sin improvisar. Sin errores.
          </p>
        </div>
      </section>

      {/* 7. WHAT'S INCLUDED - 6 TOMOS */}
      <section className="py-8 md:py-12 px-3 bg-gray-50 border-y border-gray-200" data-id="element-89">
        <div className="max-w-5xl mx-auto" data-id="element-90">
          <div className="text-center mb-6" data-id="element-91">
            <h2 className="text-xl md:text-3xl font-bold mb-2" data-id="element-92">
              📚 ¿Qué incluye exactamente el sistema?
            </h2>
            <h3 className="text-base md:text-xl font-bold text-red-600 uppercase tracking-wide" data-id="element-93">
              📖 6 TOMOS COMPLETOS (FORMACIÓN PROFESIONAL)
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-94">
            {/* Tomo 1 */}
            <div className="bg-white p-8 rounded-xl shadow-md border-t-4 border-red-600" data-id="element-95">
              <h4 className="text-2xl font-bold mb-4 flex items-center gap-2" data-id="element-96">
                <span data-id="element-97">📘</span> Tomo 1 – Fundamentos
              </h4>
              <ul className="space-y-2 text-gray-700 mb-6" data-id="element-98">
                <li data-id="element-99">• Entiende el cuerpo como sistema real</li>
                <li data-id="element-100">
                  • Patrones de movimiento, planos, ejes, contracciones y
                  palancas
                </li>
              </ul>
              <p className="font-bold text-green-700 bg-green-50 p-3 rounded-lg flex items-start gap-2" data-id="element-101">
                <span data-id="element-102">🔑</span> Empiezas a ver el entrenamiento de forma
                profesional
              </p>
            </div>

            {/* Tomo 2 */}
            <div className="bg-white p-8 rounded-xl shadow-md border-t-4 border-blue-600" data-id="element-103">
              <h4 className="text-2xl font-bold mb-4 flex items-center gap-2" data-id="element-104">
                <span data-id="element-105">📘</span> Tomo 2 – Tren Superior
              </h4>
              <ul className="space-y-2 text-gray-700 mb-6" data-id="element-106">
                <li data-id="element-107">• Domina hombros, espalda, pecho y brazos</li>
                <li data-id="element-108">• Escápula, empujes, tracciones y control técnico</li>
              </ul>
              <p className="font-bold text-green-700 bg-green-50 p-3 rounded-lg flex items-start gap-2" data-id="element-109">
                <span data-id="element-110">🔑</span> Mejora tu ejecución inmediatamente
              </p>
            </div>

            {/* Tomo 3 */}
            <div className="bg-white p-8 rounded-xl shadow-md border-t-4 border-yellow-500" data-id="element-111">
              <h4 className="text-2xl font-bold mb-4 flex items-center gap-2" data-id="element-112">
                <span data-id="element-113">📘</span> Tomo 3 – Tren Inferior
              </h4>
              <ul className="space-y-2 text-gray-700 mb-6" data-id="element-114">
                <li data-id="element-115">• El área donde más errores existen</li>
                <li data-id="element-116">• Cadera, rodilla, tobillo y patrones correctos</li>
              </ul>
              <p className="font-bold text-green-700 bg-green-50 p-3 rounded-lg flex items-start gap-2" data-id="element-117">
                <span data-id="element-118">🔑</span> Evita lesiones y mejora rendimiento
              </p>
            </div>

            {/* Tomo 4 */}
            <div className="bg-white p-8 rounded-xl shadow-md border-t-4 border-green-600" data-id="element-119">
              <h4 className="text-2xl font-bold mb-4 flex items-center gap-2" data-id="element-120">
                <span data-id="element-121">📘</span> Tomo 4 – +140 Ejercicios Analizados
              </h4>
              <ul className="space-y-2 text-gray-700 mb-6" data-id="element-122">
                <li data-id="element-123">• Biblioteca práctica profesional</li>
                <li data-id="element-124">• Técnica correcta, errores y correcciones</li>
              </ul>
              <p className="font-bold text-green-700 bg-green-50 p-3 rounded-lg flex items-start gap-2" data-id="element-125">
                <span data-id="element-126">🔑</span> Aplicación directa en el gimnasio
              </p>
            </div>

            {/* Tomo 5 */}
            <div className="bg-white p-8 rounded-xl shadow-md border-t-4 border-purple-600" data-id="element-127">
              <h4 className="text-2xl font-bold mb-4 flex items-center gap-2" data-id="element-128">
                <span data-id="element-129">📘</span> Tomo 5 – Prevención y Corrección
              </h4>
              <ul className="space-y-2 text-gray-700 mb-6" data-id="element-130">
                <li data-id="element-131">• Piensa como especialista</li>
                <li data-id="element-132">
                  • Compensaciones, errores comunes y ejercicios correctivos
                </li>
              </ul>
              <p className="font-bold text-green-700 bg-green-50 p-3 rounded-lg flex items-start gap-2" data-id="element-133">
                <span data-id="element-134">🔑</span> Te diferencia del 90% de las personas
              </p>
            </div>

            {/* Tomo 6 */}
            <div className="bg-white p-8 rounded-xl shadow-md border-t-4 border-orange-600" data-id="element-135">
              <h4 className="text-2xl font-bold mb-4 flex items-center gap-2" data-id="element-136">
                <span data-id="element-137">📘</span> Tomo 6 – Programación Inteligente
              </h4>
              <ul className="space-y-2 text-gray-700 mb-6" data-id="element-138">
                <li data-id="element-139">• Diseña entrenamientos reales</li>
                <li data-id="element-140">• Selección de ejercicios, volumen e intensidad</li>
              </ul>
              <p className="font-bold text-green-700 bg-green-50 p-3 rounded-lg flex items-start gap-2" data-id="element-141">
                <span data-id="element-142">🔑</span> Nivel profesional completo
              </p>
            </div>
          </div>

          <div className="text-center" data-id="element-143">
            <CtaButton data-id="element-144">🔥 QUIERO LOS 6 TOMOS AHORA</CtaButton>
          </div>
        </div>
      </section>

      {/* 8. BEFORE vs AFTER */}
      <section className="py-8 md:py-12 px-3 bg-white" data-id="element-145">
        <div className="max-w-5xl mx-auto" data-id="element-146">
          <h2 className="text-xl md:text-3xl font-bold text-center mb-6" data-id="element-147">
            ⚖️ Antes vs Después
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-148">
            {/* Antes */}
            <div className="bg-red-50 p-8 rounded-2xl border-2 border-red-200" data-id="element-149">
              <h3 className="text-2xl font-bold text-red-700 mb-6 flex items-center justify-center gap-2" data-id="element-150">
                <span className="text-3xl" data-id="element-151">❌</span> Antes del sistema
              </h3>
              <ul className="space-y-4 text-lg" data-id="element-152">
                <li className="flex items-center gap-3" data-id="element-153">
                  <span className="text-red-500" data-id="element-154">●</span> Entrenar sin entender
                </li>
                <li className="flex items-center gap-3" data-id="element-155">
                  <span className="text-red-500" data-id="element-156">●</span> Copiar rutinas
                </li>
                <li className="flex items-center gap-3" data-id="element-157">
                  <span className="text-red-500" data-id="element-158">●</span> Dudar de tu técnica
                </li>
                <li className="flex items-center gap-3" data-id="element-159">
                  <span className="text-red-500" data-id="element-160">●</span> Estancarte
                </li>
                <li className="flex items-center gap-3" data-id="element-161">
                  <span className="text-red-500" data-id="element-162">●</span> No diferenciarte
                </li>
              </ul>
            </div>

            {/* Después */}
            <div className="bg-green-50 p-8 rounded-2xl border-2 border-green-400 shadow-lg transform md:-translate-y-4" data-id="element-163">
              <h3 className="text-2xl font-bold text-green-700 mb-6 flex items-center justify-center gap-2" data-id="element-164">
                <span className="text-3xl" data-id="element-165">✅</span> Después del sistema
              </h3>
              <ul className="space-y-4 text-lg font-medium" data-id="element-166">
                <li className="flex items-center gap-3" data-id="element-167">
                  <span className="text-green-500" data-id="element-168">●</span> Entiendes cada
                  ejercicio
                </li>
                <li className="flex items-center gap-3" data-id="element-169">
                  <span className="text-green-500" data-id="element-170">●</span> Corriges errores en
                  tiempo real
                </li>
                <li className="flex items-center gap-3" data-id="element-171">
                  <span className="text-green-500" data-id="element-172">●</span> Evitas lesiones
                </li>
                <li className="flex items-center gap-3" data-id="element-173">
                  <span className="text-green-500" data-id="element-174">●</span> Diseñas
                  entrenamientos inteligentes
                </li>
                <li className="flex items-center gap-3" data-id="element-175">
                  <span className="text-green-500" data-id="element-176">●</span> Te conviertes en
                  alguien que sabe lo que hace
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 9. BONUSES SECTION */}
      <section className="py-8 md:py-12 px-3 bg-gray-900 text-white border-t-4 border-green-500" data-id="element-177">
        <div className="max-w-5xl mx-auto" data-id="element-178">
          <h2 className="text-xl md:text-4xl font-black text-center mb-6 text-green-400 uppercase tracking-wide" data-id="element-179">
            🎁 BONOS ESPECIALES – GRATIS HOY
          </h2>

          <div className="space-y-12" data-id="element-180">
            {/* Bono 1 */}
            <div className="bg-gray-800 rounded-2xl p-6 md:p-10 border border-gray-700 flex flex-col md:flex-row items-center gap-8 shadow-2xl" data-id="element-181">
              <div className="w-full md:w-1/2 flex justify-center" data-id="element-182">
                <a href="#compra" className="block w-full max-w-sm aspect-square transform hover:scale-105 transition-transform duration-300" data-id="element-183">
                  <img src="https://cdn.magicpatterns.com/uploads/2coDUdU9a7GWTVrN7wy3jg/mockup_bono_1.png" alt="Guía de Nutrición para Hipertrofia" className="w-full h-full object-cover drop-shadow-2xl" data-id="element-184" />
                </a>
              </div>
              <div className="w-full md:w-1/2" data-id="element-185">
                <div className="inline-block bg-green-500 text-black font-bold px-4 py-1 rounded-full mb-4 uppercase text-sm" data-id="element-186">
                  Bono #1
                </div>
                <h3 className="text-3xl font-bold mb-4" data-id="element-187">
                  Guía de Nutrición para Hipertrofia
                </h3>
                <p className="text-xl text-gray-300 mb-6" data-id="element-188">
                  Sistema práctico de 30 lecciones para maximizar tu crecimiento
                  muscular
                </p>
                <div className="bg-gray-900 p-4 rounded-lg mb-6" data-id="element-189">
                  <p className="font-bold mb-2 text-green-400" data-id="element-190">Aprende:</p>
                  <ul className="space-y-2" data-id="element-191">
                    <li className="flex items-center gap-2" data-id="element-192">
                      <CheckIcon className="text-green-400" size={20} data-id="element-193" /> Qué
                      comer
                    </li>
                    <li className="flex items-center gap-2" data-id="element-194">
                      <CheckIcon className="text-green-400" size={20} data-id="element-195" /> Cuánto
                      comer
                    </li>
                    <li className="flex items-center gap-2" data-id="element-196">
                      <CheckIcon className="text-green-400" size={20} data-id="element-197" /> Cuándo
                      comer
                    </li>
                  </ul>
                </div>
                <div className="flex items-center gap-4 text-xl" data-id="element-198">
                  <span className="text-gray-500 line-through" data-id="element-199">
                    Valor: USD $19
                  </span>
                  <span className="font-black text-green-400 text-2xl bg-green-900/30 px-4 py-1 rounded-lg border border-green-500/30" data-id="element-200">
                    HOY: GRATIS
                  </span>
                </div>
              </div>
            </div>

            {/* Bono 2 */}
            <div className="bg-gray-800 rounded-2xl p-6 md:p-10 border border-gray-700 flex flex-col md:flex-row-reverse items-center gap-8 shadow-2xl" data-id="element-201">
              <div className="w-full md:w-1/2 flex justify-center" data-id="element-202">
                <a href="#compra" className="block w-full max-w-sm aspect-square transform hover:scale-105 transition-transform duration-300" data-id="element-203">
                  <img src="https://cdn.magicpatterns.com/uploads/7M86n94DZoM4eTzUy7zKNh/mockup_bono_2.png" alt="Entrenador Personal de Éxito" className="w-full h-full object-cover drop-shadow-2xl" data-id="element-204" />
                </a>
              </div>
              <div className="w-full md:w-1/2" data-id="element-205">
                <div className="inline-block bg-green-500 text-black font-bold px-4 py-1 rounded-full mb-4 uppercase text-sm" data-id="element-206">
                  Bono #2
                </div>
                <h3 className="text-3xl font-bold mb-4" data-id="element-207">
                  Entrenador Personal de Éxito
                </h3>
                <p className="text-xl text-gray-300 mb-6" data-id="element-208">
                  Cómo destacar, conseguir clientes y vivir del fitness
                </p>
                <div className="bg-gray-900 p-4 rounded-lg mb-6" data-id="element-209">
                  <p className="font-bold mb-2 text-green-400" data-id="element-210">Aprende a:</p>
                  <ul className="space-y-2" data-id="element-211">
                    <li className="flex items-center gap-2" data-id="element-212">
                      <CheckIcon className="text-green-400" size={20} data-id="element-213" />{' '}
                      Conseguir clientes
                    </li>
                    <li className="flex items-center gap-2" data-id="element-214">
                      <CheckIcon className="text-green-400" size={20} data-id="element-215" /> Vender
                      tus servicios
                    </li>
                    <li className="flex items-center gap-2" data-id="element-216">
                      <CheckIcon className="text-green-400" size={20} data-id="element-217" />{' '}
                      Posicionarte como profesional
                    </li>
                  </ul>
                </div>
                <div className="flex items-center gap-4 text-xl" data-id="element-218">
                  <span className="text-gray-500 line-through" data-id="element-219">
                    Valor: USD $29
                  </span>
                  <span className="font-black text-green-400 text-2xl bg-green-900/30 px-4 py-1 rounded-lg border border-green-500/30" data-id="element-220">
                    HOY: GRATIS
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 10. WHAT YOU RECEIVE TODAY */}
      <section className="py-6 md:py-10 px-3 bg-white border-b-4 border-gray-200" data-id="element-221">
        <div className="max-w-3xl mx-auto bg-gray-50 border-2 border-dashed border-gray-300 rounded-2xl p-5 shadow-sm" data-id="element-222">
          <h2 className="text-lg md:text-2xl font-bold text-center mb-4" data-id="element-223">
            📦 Lo que recibes hoy
          </h2>

          <ul className="space-y-4 text-lg md:text-xl font-medium" data-id="element-224">
            <li className="flex items-start gap-3" data-id="element-225">
              <CheckIcon className="text-green-600 mt-1 flex-shrink-0" size={24} data-id="element-226" />
              <span data-id="element-227">6 Tomos completos de Kinesiología de la Musculación</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-228">
              <CheckIcon className="text-green-600 mt-1 flex-shrink-0" size={24} data-id="element-229" />
              <span data-id="element-230">Bono #1: Nutrición para Hipertrofia</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-231">
              <CheckIcon className="text-green-600 mt-1 flex-shrink-0" size={24} data-id="element-232" />
              <span data-id="element-233">Bono #2: Entrenador Personal de Éxito</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-234">
              <CheckIcon className="text-green-600 mt-1 flex-shrink-0" size={24} data-id="element-235" />
              <span data-id="element-236">Acceso inmediato</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-237">
              <CheckIcon className="text-green-600 mt-1 flex-shrink-0" size={24} data-id="element-238" />
              <span data-id="element-239">Descarga digital</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-240">
              <CheckIcon className="text-green-600 mt-1 flex-shrink-0" size={24} data-id="element-241" />
              <span data-id="element-242">Acceso de por vida</span>
            </li>
          </ul>
        </div>
      </section>

      {/* 11. PRICING SECTION (THE COMPRA SECTION) */}
      <section id="compra" className="py-10 md:py-16 px-3 bg-black text-white text-center relative overflow-hidden" data-id="element-243">
        {/* Background glow effect */}
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-full bg-green-500/10 blur-[100px] rounded-full pointer-events-none" data-id="element-244"></div>

        <div className="max-w-4xl mx-auto relative z-10" data-id="element-245">
          <h2 className="text-2xl md:text-3xl font-bold mb-4 text-green-400" data-id="element-246">
            💰 Oferta especial
          </h2>

          <div className="mb-2" data-id="element-247">
            <span className="text-lg md:text-2xl text-gray-400 line-through decoration-red-500 decoration-4" data-id="element-248">
              Precio regular: ARS $49.990
            </span>
          </div>

          <div className="mb-6" data-id="element-249">
            <span className="block text-base md:text-xl text-green-400 font-bold mb-1" data-id="element-250">
              HOY SOLO:
            </span>
            <span className="text-4xl md:text-6xl font-black text-white drop-shadow-[0_0_15px_rgba(22,163,74,0.5)]" data-id="element-251">
              ARS $19.990
            </span>
          </div>

          <CtaButton href={CHECKOUT_URL} className="text-xl md:text-2xl py-6 px-10 max-w-3xl" data-id="element-252">
            🔥 ACCEDER AHORA AL SISTEMA COMPLETO
          </CtaButton>

          <div className="mt-6 flex flex-col items-center gap-2 text-gray-400 text-sm" data-id="element-253">
            <div className="flex items-center gap-2" data-id="element-254">
              <ShieldCheckIcon size={18} data-id="element-255" />
              <span data-id="element-256">Pagos por Mercado Pago</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-257">
              <ShieldCheckIcon size={18} data-id="element-258" />
              <span data-id="element-259">Pagos 100% seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-260">
              <ShieldCheckIcon size={18} data-id="element-261" />
              <span data-id="element-262">Garantía de 7 días</span>
            </div>
          </div>
        </div>
      </section>

      {/* 12. GUARANTEE SECTION */}
      <section className="py-8 md:py-12 px-3 bg-white" data-id="element-263">
        <div className="max-w-3xl mx-auto text-center border-4 border-yellow-400 rounded-2xl p-6 md:p-10 shadow-xl relative mt-4" data-id="element-264">
          <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 bg-white rounded-full p-2" data-id="element-265">
            <div className="bg-yellow-400 text-black rounded-full p-4 shadow-lg" data-id="element-266">
              <ShieldCheckIcon size={48} data-id="element-267" />
            </div>
          </div>

          <h2 className="text-3xl md:text-4xl font-black mt-8 mb-6" data-id="element-268">
            🛡️ Garantía sin riesgo
          </h2>

          <p className="text-xl md:text-2xl font-bold mb-6" data-id="element-269">
            Pruébalo durante 7 días.
          </p>

          <p className="text-lg md:text-xl text-gray-700 mb-6" data-id="element-270">
            Si no sientes que entiendes mejor el cuerpo, mejoras tu
            entrenamiento o ganas claridad profesional…
          </p>

          <p className="text-2xl font-black text-red-600 mb-4" data-id="element-271">
            Te devolvemos el 100% del dinero.
          </p>

          <p className="text-xl font-bold text-gray-500 uppercase tracking-widest" data-id="element-272">
            Sin preguntas.
          </p>
        </div>
      </section>

      {/* 13. TESTIMONIALS SECTION */}
      <section className="py-8 md:py-12 px-3 bg-gray-100" data-id="element-273">
        <div className="max-w-6xl mx-auto" data-id="element-274">
          <h2 className="text-xl md:text-3xl font-bold text-center mb-6" data-id="element-275">
            Lo que dicen quienes ya están aplicando el sistema
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-276">
            {/* Testimonial 1 */}
            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-200 flex flex-col h-full" data-id="element-277">
              <div className="flex text-yellow-400 mb-4" data-id="element-278">
                {[...Array(5)].map((_, i) => <StarIcon key={i} size={20} fill="currentColor" data-id="element-279" />)}
              </div>
              <p className="text-gray-700 italic flex-grow mb-6" data-id="element-280">
                "Siempre entrenaba copiando rutinas de internet. Con este
                sistema entendí por primera vez cómo funciona realmente el
                cuerpo. Ahora puedo corregir errores y diseñar mis propios
                entrenamientos con confianza."
              </p>
              <div className="flex items-center gap-4 pt-4 border-t border-gray-100" data-id="element-281">
                <div className="w-12 h-12 bg-blue-100 text-blue-700 rounded-full flex items-center justify-center font-bold text-xl" data-id="element-282">
                  MG
                </div>
                <div data-id="element-283">
                  <p className="font-bold" data-id="element-284">Martín G., 28 años</p>
                  <p className="text-sm text-gray-500" data-id="element-285">
                    Buenos Aires - Estudiante de Educación Física
                  </p>
                </div>
              </div>
            </div>

            {/* Testimonial 2 */}
            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-200 flex flex-col h-full" data-id="element-286">
              <div className="flex text-yellow-400 mb-4" data-id="element-287">
                {[...Array(5)].map((_, i) => <StarIcon key={i} size={20} fill="currentColor" data-id="element-288" />)}
              </div>
              <p className="text-gray-700 italic flex-grow mb-6" data-id="element-289">
                "Llevo 5 años como entrenador y este material me dio
                herramientas que no encontré en ningún curso. La biomecánica
                explicada así de claro es un antes y un después."
              </p>
              <div className="flex items-center gap-4 pt-4 border-t border-gray-100" data-id="element-290">
                <div className="w-12 h-12 bg-red-100 text-red-700 rounded-full flex items-center justify-center font-bold text-xl" data-id="element-291">
                  LR
                </div>
                <div data-id="element-292">
                  <p className="font-bold" data-id="element-293">Lucas R., 34 años</p>
                  <p className="text-sm text-gray-500" data-id="element-294">
                    Córdoba - Entrenador Personal
                  </p>
                </div>
              </div>
            </div>

            {/* Testimonial 3 */}
            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-200 flex flex-col h-full" data-id="element-295">
              <div className="flex text-yellow-400 mb-4" data-id="element-296">
                {[...Array(5)].map((_, i) => <StarIcon key={i} size={20} fill="currentColor" data-id="element-297" />)}
              </div>
              <p className="text-gray-700 italic flex-grow mb-6" data-id="element-298">
                "Lo uso como complemento de la carrera y es increíble. Los tomos
                de tren superior e inferior son una joya. Me ayudó a entender
                conceptos que en la facultad me costaban."
              </p>
              <div className="flex items-center gap-4 pt-4 border-t border-gray-100" data-id="element-299">
                <div className="w-12 h-12 bg-green-100 text-green-700 rounded-full flex items-center justify-center font-bold text-xl" data-id="element-300">
                  SM
                </div>
                <div data-id="element-301">
                  <p className="font-bold" data-id="element-302">Santiago M., 26 años</p>
                  <p className="text-sm text-gray-500" data-id="element-303">
                    Rosario - Estudiante de Kinesiología
                  </p>
                </div>
              </div>
            </div>

            {/* Testimonial 4 */}
            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-200 flex flex-col h-full" data-id="element-304">
              <div className="flex text-yellow-400 mb-4" data-id="element-305">
                {[...Array(5)].map((_, i) => <StarIcon key={i} size={20} fill="currentColor" data-id="element-306" />)}
              </div>
              <p className="text-gray-700 italic flex-grow mb-6" data-id="element-307">
                "Mis alumnos notaron la diferencia. Desde que aplico lo del
                sistema, puedo explicar cada ejercicio con fundamento. Me
                posicioné como un profesional real."
              </p>
              <div className="flex items-center gap-4 pt-4 border-t border-gray-100" data-id="element-308">
                <div className="w-12 h-12 bg-purple-100 text-purple-700 rounded-full flex items-center justify-center font-bold text-xl" data-id="element-309">
                  FA
                </div>
                <div data-id="element-310">
                  <p className="font-bold" data-id="element-311">Federico A., 31 años</p>
                  <p className="text-sm text-gray-500" data-id="element-312">
                    Mendoza - Entrenador de Gimnasio
                  </p>
                </div>
              </div>
            </div>

            {/* Testimonial 5 */}
            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-200 flex flex-col h-full md:col-span-2 lg:col-span-1 lg:col-start-2" data-id="element-313">
              <div className="flex text-yellow-400 mb-4" data-id="element-314">
                {[...Array(5)].map((_, i) => <StarIcon key={i} size={20} fill="currentColor" data-id="element-315" />)}
              </div>
              <p className="text-gray-700 italic flex-grow mb-6" data-id="element-316">
                "Tengo 15 años entrenando y pensé que sabía todo. Este sistema
                me demostró que estaba cometiendo errores básicos. Ahora entreno
                mejor que nunca."
              </p>
              <div className="flex items-center gap-4 pt-4 border-t border-gray-100" data-id="element-317">
                <div className="w-12 h-12 bg-yellow-100 text-yellow-700 rounded-full flex items-center justify-center font-bold text-xl" data-id="element-318">
                  NP
                </div>
                <div data-id="element-319">
                  <p className="font-bold" data-id="element-320">Nicolás P., 38 años</p>
                  <p className="text-sm text-gray-500" data-id="element-321">
                    La Plata - Apasionado del Fitness
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 14. FAQ SECTION */}
      <section className="py-8 md:py-12 px-3 bg-white" data-id="element-322">
        <div className="max-w-3xl mx-auto" data-id="element-323">
          <h2 className="text-xl md:text-3xl font-bold text-center mb-6" data-id="element-324">
            ❓ Preguntas frecuentes
          </h2>

          <div className="space-y-4" data-id="element-325">
            {/* FAQ 1 */}
            <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-326">
              <button onClick={() => toggleFaq(0)} className="w-full px-6 py-4 text-left font-bold text-lg flex justify-between items-center bg-gray-50 hover:bg-gray-100 transition-colors" data-id="element-327">
                <span data-id="element-328">¿Es para principiantes o avanzados?</span>
                {openFaq === 0 ? <ChevronUpIcon data-id="element-329" /> : <ChevronDownIcon data-id="element-330" />}
              </button>
              {openFaq === 0 && <div className="px-6 py-4 bg-white text-gray-700 border-t border-gray-200" data-id="element-331">
                  Para ambos. Empiezas desde la base y avanzas a nivel
                  profesional.
                </div>}
            </div>

            {/* FAQ 2 */}
            <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-332">
              <button onClick={() => toggleFaq(1)} className="w-full px-6 py-4 text-left font-bold text-lg flex justify-between items-center bg-gray-50 hover:bg-gray-100 transition-colors" data-id="element-333">
                <span data-id="element-334">¿Necesito experiencia previa?</span>
                {openFaq === 1 ? <ChevronUpIcon data-id="element-335" /> : <ChevronDownIcon data-id="element-336" />}
              </button>
              {openFaq === 1 && <div className="px-6 py-4 bg-white text-gray-700 border-t border-gray-200" data-id="element-337">
                  No. El sistema está diseñado paso a paso.
                </div>}
            </div>

            {/* FAQ 3 */}
            <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-338">
              <button onClick={() => toggleFaq(2)} className="w-full px-6 py-4 text-left font-bold text-lg flex justify-between items-center bg-gray-50 hover:bg-gray-100 transition-colors" data-id="element-339">
                <span data-id="element-340">¿Es solo teoría?</span>
                {openFaq === 2 ? <ChevronUpIcon data-id="element-341" /> : <ChevronDownIcon data-id="element-342" />}
              </button>
              {openFaq === 2 && <div className="px-6 py-4 bg-white text-gray-700 border-t border-gray-200" data-id="element-343">
                  No. Es aplicación directa en el entrenamiento real.
                </div>}
            </div>

            {/* FAQ 4 */}
            <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-344">
              <button onClick={() => toggleFaq(3)} className="w-full px-6 py-4 text-left font-bold text-lg flex justify-between items-center bg-gray-50 hover:bg-gray-100 transition-colors" data-id="element-345">
                <span data-id="element-346">¿Es material digital?</span>
                {openFaq === 3 ? <ChevronUpIcon data-id="element-347" /> : <ChevronDownIcon data-id="element-348" />}
              </button>
              {openFaq === 3 && <div className="px-6 py-4 bg-white text-gray-700 border-t border-gray-200" data-id="element-349">
                  Sí. Acceso inmediato desde cualquier dispositivo.
                </div>}
            </div>
          </div>
        </div>
      </section>

      {/* 15. FINAL CTA SECTION */}
      <section className="py-10 md:py-16 px-3 bg-black text-white text-center" data-id="element-350">
        <div className="max-w-4xl mx-auto" data-id="element-351">
          <h2 className="text-2xl md:text-4xl font-black mb-4 text-green-400" data-id="element-352">
            💪 Entrenar puede ser diferente
          </h2>

          <div className="text-base md:text-xl space-y-3 mb-6" data-id="element-353">
            <p data-id="element-354">No necesitas más rutinas. No necesitas más videos.</p>
            <p className="font-bold text-red-500 text-2xl md:text-3xl" data-id="element-355">
              🎯 Necesitas entender lo que haces
            </p>
          </div>

          <div className="bg-gray-900 p-5 rounded-2xl border border-gray-800 mb-6" data-id="element-356">
            <p className="text-lg md:text-xl font-bold mb-2" data-id="element-357">
              Accede ahora al Sistema Completo de Kinesiología de la Musculación
            </p>
            <p className="text-xl text-gray-400 italic" data-id="element-358">
              Porque no se trata de entrenar más… Se trata de entrenar con
              criterio.
            </p>
          </div>

          <CtaButton className="text-xl md:text-2xl py-6 px-10" data-id="element-359">
            🔥 ACCEDER AHORA
          </CtaButton>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-500 text-center py-8 px-4 text-sm" data-id="element-360">
        <p data-id="element-361">
          © {new Date().getFullYear()} Sistema Completo de Kinesiología de la
          Musculación. Todos los derechos reservados.
        </p>
        <p className="mt-2 text-xs max-w-2xl mx-auto" data-id="element-362">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </footer>
    </div>;
}